/**
 * Company: SPHMedia
 * Description: [Displays short form videos for articles]
 */

import KakiMakanDesktopVideo from "@components/Layouts/KakiMakanVideo/KakiMakanDesktopVideo";
import KakiMakanMobileVideo from "@components/Layouts/KakiMakanVideo/KakiMakanMobileVideo";
import { IS_PLAYWRIGHT_TEST } from "@helper/getEnvVariables";
import { LatestVideoResponse } from "@hooks/transformer/useBrightcoveResponse";
import { Heading } from "@sphtech/sph-web-ui/elements/Heading";
import { ReactElement, RefObject } from "react";

type ShortFormVideosProps = {
  containerRef: RefObject<HTMLDivElement>;
  videos: LatestVideoResponse[];
  handleOnEndedVideo: () => void;
  handleOnClickThumbnail: (props: LatestVideoResponse) => void;
  playing?: LatestVideoResponse;
};

/**
 * ShortFormVideos
 * Description: [Renders both desktop & mobile short form videos in article pages]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function ShortFormVideos({
  containerRef,
  videos,
  handleOnClickThumbnail,
  handleOnEndedVideo,
  playing,
}: ShortFormVideosProps): ReactElement {
  if (videos.length === 0 || IS_PLAYWRIGHT_TEST === "true") {
    return <></>;
  }

  return (
    <div className="flex flex-col gap-3">
      <div className="mt-4 lg:mt-6 w-full h-0.5 bg-brand-primary"></div>
      <Heading
        Element="h2"
        className="text-text-muted text-sm font-semibold leading-[150%]"
      >
        Ringkas
      </Heading>
      <div>
        <div className="hidden lg:block">
          <KakiMakanDesktopVideo
            containerRef={containerRef}
            paginated={videos}
            handleOnEndedVideo={handleOnEndedVideo}
            handleOnClickThumbnail={handleOnClickThumbnail}
            playing={playing}
            varinat="short_form_video"
          />
        </div>
        <div className="lg:hidden">
          <KakiMakanMobileVideo
            videos={videos}
            containerRef={containerRef}
            handleOnEndedVideo={handleOnEndedVideo}
            handleOnClickThumbnail={handleOnClickThumbnail}
            playing={playing}
          />
        </div>
      </div>
    </div>
  );
}
